var _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 100,
    r: 11,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 52,
    r: 11,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 148,
    r: 11,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 100,
    r: 15,
    fill: "#ffffff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 100,
    x2: 115,
    y2: 52,
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 100,
    x2: 115,
    y2: 148,
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 52,
    x2: 168,
    y2: 100,
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 148,
    x2: 168,
    y2: 100,
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c31e6d29d208798ccea1ce0ff28059a1.svg";
export { ForwardRef as ReactComponent };